__turbopack_context__.v({
  "cancelButton": "missingSomethingModalForm-module-scss-module__eP5_oW__cancelButton",
  "headerText": "missingSomethingModalForm-module-scss-module__eP5_oW__headerText",
  "inputContainer": "missingSomethingModalForm-module-scss-module__eP5_oW__inputContainer",
  "modalDescription": "missingSomethingModalForm-module-scss-module__eP5_oW__modalDescription",
  "textarea": "missingSomethingModalForm-module-scss-module__eP5_oW__textarea",
});
